import { render, staticRenderFns } from "./PopoverComp.vue?vue&type=template&id=204e9579"
import script from "./PopoverComp.vue?vue&type=script&lang=js"
export * from "./PopoverComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports